module.exports = __webpack_public_path__ + "img/liuc_img.dff01f28.png";